import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Image } from '@grandvisionhq/common';

const StoreTileImage = (_param)=> {
    var { className , alt , url  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "alt",
        "url"
    ]);
    return React.createElement("div", {
        className: "store-tile__image-wrapper"
    }, /*#__PURE__*/ React.createElement(Image, swcHelpers.extends({}, rest, {
        alt: alt,
        url: url,
        className: "store-tile__image",
        cover: true
    })));
};
var StoreTileImage$1 = StoreTileImage;

export { StoreTileImage$1 as default };
//# sourceMappingURL=StoreTileImage.js.map
